import { Card, Grid, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import failed from '../Images/failed.png'
import failedMsg from '../Images/failedMsg.png'
import Header from './Header'
import Footer from './Footer'
import 'react-loading-skeleton/dist/skeleton.css'
import { DateUtilService } from '../../services/date-util-service'

const PaymentFailed = (props) => {
    const [recievedResponse, setRecievedResponse] = useState({
        Comments: '',
        Status: '',
        TransactionId: '',
        TrackId: '',
        Amount: '',
        TransactionDate: '',
        Image: undefined,
        ImageTitle: undefined,
        textColor: 'black',
    })
    return (
        <>
            <Header />
            <div
                className="m-sm-30 transactionBody"
                style={{ paddingTop: '50px', paddingBottom: '100px' }}
            >
                <Grid pt={6} container spacing={0}>
                    <Grid item xs={0} md={2}></Grid>
                    <Grid item xs={12} md={8}>
                        <Card
                            className="px-6 pt-2 pb-4"
                            style={{ backgroundColor: 'white', margin: 10 }}
                        >
                            <div
                                style={{
                                    backgroundColor: '#2177F9',
                                    padding: '10px',
                                    color: 'white',
                                }}
                            >
                                <Typography>TRANSACTION STATUS</Typography>
                            </div>
                            <Grid
                                container
                                spacing={2}
                                style={{ padding: '20px' }}
                            >
                                <Grid item xs={12} md={4}>
                                    <div>
                                        <center>
                                            <img
                                                style={{
                                                    margin: '10px',
                                                    width: '80px',
                                                }}
                                                src={failed}
                                                alt="failed"
                                            />
                                            <br />
                                            <img
                                                style={{
                                                    margin: '10px',
                                                    width: '180px',
                                                }}
                                                src={failedMsg}
                                                alt="failed"
                                            />
                                        </center>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={7}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={5}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                }}
                                            >
                                                Transaction Status:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={7}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                    color: 'red',
                                                }}
                                            >
                                                Transaction Failed
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                }}
                                            >
                                                Remarks:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={7}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                    color: 'red',
                                                }}
                                            >
                                                User Timed Out
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                }}
                                            >
                                                Transaction ID:
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={7}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                    color: recievedResponse.textColor,
                                                }}
                                            >
                                                {recievedResponse.TransactionId}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                }}
                                            >
                                                TrackId:
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={7}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                    color: recievedResponse.textColor,
                                                }}
                                            >
                                                {recievedResponse.TrackId}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                }}
                                            >
                                                Transaction Amount:
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={7}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                    color: 'red',
                                                }}
                                            >
                                                {DateUtilService.formatToCurrency(
                                                    recievedResponse.Amount
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                }}
                                            >
                                                Transaction Date:
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={7}>
                                            <Typography
                                                style={{
                                                    fontSize: '14px',
                                                    padding: '10px',
                                                    color: 'red',
                                                }}
                                            >
                                                {DateUtilService.getDateStringInLocalTimeZone()}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <div
                                    style={{
                                        padding: '10px',
                                        marginBottom: '20px',
                                    }}
                                >
                                    <center>
                                        <Typography
                                            style={{
                                                fontSize: '20px',
                                                color: '#175aa9',
                                            }}
                                        >
                                            Please Contact Vayana Team for more
                                            Details
                                        </Typography>
                                    </center>
                                </div>
                            </Grid>
                        </Card>
                    </Grid>
                    <Grid item xs={0} md={2}></Grid>
                </Grid>
            </div>
            <Footer />
        </>
    )
}

export default PaymentFailed
